import {
  Button,
  Col,
  DeleteButton,
  EditButton,
  Form,
  Icons,
  Input,
  List,
  Row,
  Select,
  Space,
  Table,
  TextField,
  useTable,
} from "@pankod/refine-antd";
import { CrudFilters, IResourceComponentsProps } from "@pankod/refine-core";
import { ButtonExport } from "components/buttonExport";
import useMediaScreen from "hooks/useMediaScreen";
import React from "react";
import { IRequest } from "types/request.interface";
import { ITransactionResponse } from "types/transaction.interface";
import { formatDateTime, getOrderNumber } from "utils";

export const QuestionList: React.FC<IResourceComponentsProps> = () => {
  const { tableProps, searchFormProps }: any = useTable<ITransactionResponse>({
    resource: "questions",
    initialPageSize: 100,
    onSearch: (params) => {
      const filters: CrudFilters = [];
      const input: any = params;
      filters.push({
        field: "search",
        operator: "in",
        value: {
          search: input?.search || "",
          status: input?.status || "",
          reason: input?.reason || "",
        },
      });
      return filters;
    },
  });
  const pageSize = tableProps?.pagination?.pageSize;
  const current = tableProps?.pagination?.current;
  const { isMobile } = useMediaScreen();

  const optionsStatus = [
    {
      label: "Pending",
      value: "pending",
    },
    {
      label: "Resolved",
      value: "resolved",
    },
  ];

  const dataSelectReason = [
    {
      label: `All reason`,
      value: "",
    },
    {
      label: `General Inquiry`,
      value: "General Inquiry",
    },
    {
      label: `Subscription Applicant`,
      value: "Subscription Applicant",
    },
    {
      label: `Contributor Applicant`,
      value: "Contributor Applicant",
    },
    {
      label: `Advertise / Promote Music`,
      value: "Advertise Promote_Music",
    },
    {
      label: `Report A Bug/Issue`,
      value: "Report A Bug/Issue",
    },
  ];

  return (
    <List>
      <Row style={{ display: "block" }}>
        <Col>
          <Form layout="vertical" {...searchFormProps}>
            <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", flexWrap: 'wrap' }}>
              <Form.Item
                label="Search"
                name="search"
                style={{ width: isMobile ? "100%" : "50%" }}
                initialValue=""
              >
                <Input
                  placeholder="Content "
                  prefix={<Icons.SearchOutlined />}
                />
              </Form.Item>
              <Form.Item
                style={{ width: isMobile ? "100%" : "110px", marginLeft: isMobile ? "0" : "20px" }}
                label="Status"
                name="status"
              >
                <Select
                  defaultValue={optionsStatus[0]}
                  options={optionsStatus}
                />
              </Form.Item>
              <Form.Item
                style={{ width: isMobile ? "100%" : "200px", marginLeft: isMobile ? "0" : "20px" }}
                label="Reason"
                name="reason"
              >
                <Select
                  defaultValue={dataSelectReason[0]}
                  options={dataSelectReason}
                />
              </Form.Item>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Form.Item>
                <Button htmlType="submit" type="primary">
                  Filter
                </Button>
              </Form.Item>
              <ButtonExport path="questions" />
            </div>
          </Form>
        </Col>
        <Col>
          <Table
            {...tableProps}
            pagination={{
              ...tableProps?.pagination,
              showSizeChanger: true,
            }}
            rowKey="id"
          >
            <Table.Column
              dataIndex="_id"
              key="_id"
              title="Index"
              render={(value, item, index) => (
                <TextField value={getOrderNumber(current, pageSize, index)} />
              )}
            />
            <Table.Column
              dataIndex="content"
              key="content"
              title="Content"
              render={(value) => (
                <TextField
                  value={
                    <div
                      style={{
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        WebkitLineClamp: 3,
                        maxHeight: "60px",
                      }}
                    >
                      {value}
                    </div>
                  }
                />
              )}
              sorter
            />
            <Table.Column
              title="CreatedAt"
              dataIndex="createdAt"
              key="createdAt"
              render={(value) => <TextField value={formatDateTime(value)} />}
              sorter
            />
            <Table.Column
              dataIndex="emailAddress"
              key="emailAddress"
              title="Email Address"
              render={(value) => <TextField value={value} />}
              sorter
            />
            <Table.Column
              dataIndex="status"
              key="status"
              title="Status"
              render={(value) => <TextField value={value || "pending"} />}
              sorter
            />
            <Table.Column<IRequest>
              title="Actions"
              dataIndex="actions"
              render={(_, record: any) => (
                <Space>
                  {/* <ShowButton hideText size="small" recordItemId={record._id} /> */}
                  <EditButton hideText size="small" recordItemId={record._id} />
                  <DeleteButton
                    hideText
                    size="small"
                    recordItemId={record._id}
                  />
                </Space>
              )}
            />
          </Table>
        </Col>
      </Row>
    </List>
  );
};
